import { Table, Carousel } from '@scuf/common';
import { formatDate } from 'helpers';
import { OrderDTO } from 'models/spareParts/orderById';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { orderAtom } from 'resources/atoms/spareParts';
import useFetch from 'helpers/hooks/useFetch';
import { SPARE_PARTS } from 'resources';
import { useSetRecoilState } from 'recoil';
import { notificationAtom } from 'resources';
import { useRef } from 'react';

const ProductAddedContract: React.FC = () => {
    const [orderData] = useRecoilState<OrderDTO>(orderAtom);
    const { t } = useTranslation(['spareparts', 'common', 'notification']);
    const setNotification = useSetRecoilState(notificationAtom);
    const [imagesMap, setImagesMap] = useState<{ [key: string]: string[] }>({});
    const [carregaImagem, setCarregaImagem] = useState<boolean>(false);
    const loadedPartsRef = useRef<Set<string>>(new Set());
    const [imgModalVisible, setIMGModalVisible] = useState<boolean>(false);
    const [images, setImages] = useState<string[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const [imageLoading, setImageLoading] = useState(true);

    const [, fetchImages] = useFetch<string[], any>({
        url: SPARE_PARTS.getImages,
        method: 'POST'
        //onError: t('notification:critical.ErroImage')
    });

    const getImages = async (partNumbers: string[]): Promise<void> => {
        try {
            await fetchImages(partNumbers, resp => {
                const imagesResponse = resp.data;
                const newImagesMap: { [key: string]: string[] } = {};

                let allImagesEmpty = true;

                imagesResponse.forEach((imageData: any) => {
                    if (imageData.partNumber && Array.isArray(imageData.images)) {
                        if (imageData.images.length > 0) {
                            newImagesMap[imageData.partNumber] = imageData.images;
                            allImagesEmpty = false;
                        }
                    }
                });

                if (Object.keys(newImagesMap).length > 0) {
                    setImagesMap(prev => ({ ...prev, ...newImagesMap }));
                }

                setCarregaImagem(false);
            });
        } catch (error) {
            setNotification({
                type: 'critical',
                message: t('notification:critical.ErroImage')
            });
        }
    };

    useEffect(() => {
        if (carregaImagem) {
            if (orderData && orderData.orderItems) {
                const partNumbers = orderData.orderItems.map(item => item.partNumber!);
                getImages(partNumbers);
            }
        }
    }, [carregaImagem]);

    useEffect(() => {
        setCarregaImagem(true);
    }, [orderData.id]);

    useEffect(() => {
        if (carregaImagem && orderData?.orderItems?.length) {
            const partNumbers = orderData.orderItems.map(item => item?.code ?? 'sem partNumber');
            console.log('PartNumbers:', partNumbers);
            getImages(partNumbers);
        }
    }, [carregaImagem, orderData]);

    useEffect(() => {
        console.log('orderData atualizado:', orderData);
        setCarregaImagem(true);
    }, [orderData]);

    const openImageModal = (partNumber: string) => {
        const imgs = imagesMap[partNumber] || [];
        setImages(imgs);
        setCurrentImageIndex(0);
        setIMGModalVisible(true);
    };

    const renderIMGModal = () => {
        if (!imgModalVisible) return null;

        return (
            <div className="overlay-wrapper">
                <div className="overlay" onClick={() => setIMGModalVisible(false)}>
                    {images.length > 0 ? (
                        <div className="carousel-container" onClick={e => e.stopPropagation()}>
                            <img
                                src={`data:image/jpeg;base64,${images[currentImageIndex]}`}
                                alt={`Imagem ${currentImageIndex + 1} de ${images.length}`}
                                className="image-carousel"
                                onLoad={() => setImageLoading(false)}
                                onError={() => setImageLoading(false)}
                            />
                            <div className="carousel-controls">
                                <button
                                    className="chevron-left"
                                    disabled={currentImageIndex === 0}
                                    onClick={() => {
                                        setCurrentImageIndex(prev => Math.max(prev - 1, 0));
                                        setImageLoading(true);
                                    }}
                                >
                                    ◀
                                </button>
                                <button
                                    className="chevron-right"
                                    disabled={currentImageIndex === images.length - 1}
                                    onClick={() => {
                                        setCurrentImageIndex(prev => Math.min(prev + 1, images.length - 1));
                                        setImageLoading(true);
                                    }}
                                >
                                    ▶
                                </button>
                            </div>
                        </div>
                    ) : (
                        <p className="WarningNotImage">{t('common:translation.NoImages')}</p>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            {imgModalVisible && renderIMGModal()}
            <div className="div-datatable">
                <div>
                    <h2>
                        {t('translation.AddedProducts')} {'(' + orderData?.orderItems.length + ')'}{' '}
                    </h2>
                    <Table>
                        <Table.Header>
                            <Table.HeaderCell content={t('common:translation.Image')} />
                            <Table.HeaderCell content={t('common:translation.Item')} />
                            <Table.HeaderCell content={''} />
                            <Table.HeaderCell content={t('translation.EquipSerial')} />
                            <Table.HeaderCell content={t('translation.SerialPart')} />
                            <Table.HeaderCell content={t('common:translation.Date')} />
                            <Table.HeaderCell content={t('common:translation.Problem')} />
                        </Table.Header>
                        <Table.Body>
                            {orderData?.orderItems &&
                                orderData?.orderItems?.map((item: any) => (
                                    <Table.Row>
                                        <Table.Cell onClick={() => openImageModal(item.partNumber!)}>
                                            {imagesMap[item.partNumber]?.length > 0 ? (
                                                <Carousel
                                                    className="carouselcart"
                                                    autoPlay={true}
                                                    transitionTime={6000}
                                                    height={200}
                                                >
                                                    {imagesMap[item.partNumber].map((image: string, idx: number) => (
                                                        <Carousel.Slide
                                                            key={idx}
                                                            className="carousel-image"
                                                            image={`data:image/png;base64,${image}`}
                                                        />
                                                    ))}
                                                </Carousel>
                                            ) : (
                                                <img
                                                    className="imagepd"
                                                    alt="imagem padrão"
                                                    src={require('../../../../../../assets/HON192.png')}
                                                />
                                            )}
                                        </Table.Cell>
                                        <Table.Cell>{item.partNumber}</Table.Cell>
                                        <Table.Cell>{item.description} </Table.Cell>
                                        <Table.Cell>{item.serialNumberEquipment} </Table.Cell>
                                        <Table.Cell>{item.serialNumberPart} </Table.Cell>
                                        <Table.Cell>{formatDate(item.createdAt)} </Table.Cell>
                                        <Table.Cell>{item.descriptionDefectFound} </Table.Cell>
                                    </Table.Row>
                                ))}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </>
    );
};

export default ProductAddedContract;
